<template>
  <LinkButton
    v-if="hasSmarthomeCameraCategory"
    tag="a"
    to="/downloads/smarthome-unterstuetzte-kameras.pdf"
    target="_blank"
    text
    class="camera-link"
  >
    Unsere Kameras im Überblick (PDF)
    <Arrow
      direction="right"
      class="camera-link__icon"
      tag="span"
    />
  </LinkButton>
</template>

<script lang="ts" setup>
import { computed, type PropType } from 'vue';
import { LinkButton, Arrow } from '@i22-td-smarthome/component-library';
import type { Offer } from '~/lib/goliath/offer-by-slugs';

const props = defineProps({
  offer: { type: Object as PropType<Offer>, default: () => ({}) },
});

const hasSmarthomeCameraCategory = computed(() => {
  const productCategories = props.offer?.product?.family?.categories;
  if (!productCategories) return false;
  return productCategories.some((category) => category?.categoryNumber === 'T_SHKAMERA');
});
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.camera-link {
  display: flex;
  align-items: center;
  gap: 0.5 * $grid-base;
  margin-block: 2 * $grid-base;

  &__icon {
    position: relative;
    color: currentColor;
    width: 0.7em;
    height: 0.5em;
  }
}
</style>
